import { nanoid } from "nanoid";

export const initialRAD = {
  id: "",
  status: "initial",
  version: 0,
  info: {
    name: "",
    principal_process_id: "",
    viewpoint: "",
    description: "",
    lead_role: "",
    targetEngine: "reachability",
    merged: false,
  },
  roles: [],
  states: [],
  connections: [],
};

// Create a new RAD instance based on arguments
export const createRAD = ({
  id,
  name = "New RAD",
  status = "initial",
  principal_process_id = "",
  viewpoint = "",
  description = "",
  lead_role = "",
} = {}) => {
  const newId = id || nanoid(); // ✅ always fresh if not passed

  return {
    id: newId,
    status,
    version: 0,
    info: {
      name,
      principal_process_id,
      viewpoint,
      description,
      lead_role,
      targetEngine: "reachability",
      merged: false,
    },
  };
};
